// extracted by mini-css-extract-plugin
export default {"dashboard":"StatisticsDashboard_dashboard__o9J1U"};